import { Alert, Box, Container } from "@mui/material";
import { useEffect } from "react";
import AppBar from "../components/AppBar";
import { useSidebarLayout } from "../zustand/useSidebarStore";
import NavBar from "../components/NavBar";
import TableShipments from "../components/tables/TableShipments";
import DateRangePickerComponent from "../components/inputs/DateRangePicker";
import { useDateRangeStore } from "../zustand/useDateRangeStore";
import { useEnvioStore } from "../zustand/useEnviosStore";

export default function ShipmentsRoute() {
  const sidebar = useSidebarLayout();
  const { fechaInicio, fechaFin, setFechas } = useDateRangeStore();
  const { fetchAllEnvios, resetEnvios } = useEnvioStore();

  function fetchData() {
    resetEnvios();
    fetchAllEnvios();
  }

  useEffect(() => {
    fetchAllEnvios();
  }, [fetchAllEnvios]);


  return (
    <>
      <AppBar />
      <Container maxWidth={false} sx={{ mt: 1, p: 1, ...sidebar }}>
        <NavBar />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
            marginTop: 2,
          }}
        >
          <DateRangePickerComponent
            start={fechaInicio}
            end={fechaFin}
            setDate={setFechas}
            handleChange={fetchData}
          />
          <Alert severity="warning" sx={{ mt: 1 }}>
            <strong>Precaución:</strong> Los cambios de estado al envío se aplicarán de forma masiva a todos los paquetes incluidos en el corte.
          </Alert>
        </Box>
        <TableShipments />
      </Container>
    </>
  );
}
